import { required } from 'vuelidate/lib/validators'
import Pagination from "../../../components/Pagination.vue";
import AIModelService from "../../../services/AIModel.service";
import { alertResponseSuccess, alertResponseError } from "../../../helpers/general";
import { ERRORS_CODE } from "../../../const/error_code";
import { INFERENCE_STATUS, AI_MODEL_TYPE } from "../../../const/aimodel";
import * as Swal from "sweetalert2";

export default {
    components: {
        appPagination: Pagination
    },
    data() {
        return {
            page_title: '',
            pagination : {
                currentPage: 1,
                pageCount: 1,
            },
            errors: {},
            aiModel: {
                id: '',
                name: '',
                type: ''
            },
            formSubmitted: false,
            record_condition: '',
            model_training_id: 0,
            pred_field_prefix: 'pred_',
            option_thresh: 0.5,
            inferences: [],
            finishTraines: [],
            INFERENCE_STATUS: INFERENCE_STATUS,
            AI_MODEL_TYPE: AI_MODEL_TYPE
        }
    },
    methods: {
        inference() {
            Swal.fire({
                text: this.$t("ai_model_inference.confirm"),
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: this.$t('common.yes'),
                cancelButtonText: this.$t('common.no'),
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    const isNeuralNetwork = this.aiModel.type === AI_MODEL_TYPE.neural_network;
                    const inferenceParams = isNeuralNetwork
                        ? [this.aiModel.id, this.record_condition, this.model_training_id, this.pred_field_prefix, this.option_thresh]
                        : [this.aiModel.id, this.record_condition];

                    return AIModelService.inference(...inferenceParams).then((response) => {
                    
                        this.formSubmitted = false;
                        if (response.data.success) {
                            alertResponseSuccess(this.$t("common_message.inference_success"));
                        }
                        this.getAllInferences(this.aiModel.id);
                    }).catch((error) => {
                        this.getAllInferences(this.aiModel.id);
                        if (error.response.data.errorCode === ERRORS_CODE.SUBSCRIPTION_IS_NOT_ACTIVE) {
                            alertResponseError(this.$t("message_error.SUBSCRIPTION_IS_NOT_ACTIVE"));
                        }else if (error.response.data.errorCode === ERRORS_CODE.AI_MODEL_LAYER_NOT_VALID) {
                            alertResponseError(this.$t("message_error.AI_MODEL_LAYER_NOT_VALID"));
                        }else if (error.response.data.errorCode === ERRORS_CODE.AI_MODEL_RUN_INFERENCE_FAILED) {
                            alertResponseError(this.$t("message_error.AI_MODEL_RUN_INFERENCE_FAILED"));
                        }else if (error.response.data.errorCode === ERRORS_CODE.INFERENCES_COUNT_GREATER_THAN_PLAN_MAX_VOLUME) {
                            alertResponseError(this.$t("message_error.INFERENCES_COUNT_GREATER_THAN_PLAN_MAX_VOLUME"));
                        }else {
                            return alertResponseError(error.response.data.error);
                        }
                        
                    });
                }
            });
        },
        handleForm() {
            this.formSubmitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            return this.inference();
        },
        getAllInferences(id) {
            AIModelService.getAllInferences(id, this.pagination.currentPage).then((response) => {
                this.inferences = response.data.data.results;
                this.pagination.pageCount = response.data.data.count;
            }).catch((error) => {
                if (error.response.data.errorCode === ERRORS_CODE.AI_MODEL_NOT_FOUND) {
                    alertResponseError(this.$t("ai_model_detail.ai_model_not_found"));
                } else {
                    alertResponseError(error);
                }
            });
        },
        getAllFinishTrains(id) {
            AIModelService.getAllFinishTrains(id).then((response) => {
                this.finishTraines = response.data.data.results;
                this.model_training_id = this.getLowestLossTrainIndex;
            }).catch((error) => {
                if (error.response.data.errorCode === ERRORS_CODE.AI_MODEL_NOT_FOUND) {
                    alertResponseError(this.$t("ai_model_detail.ai_model_not_found"));
                } else {
                    alertResponseError(error);
                }
            });
        },        
    },
    created() {
        document.title = this.$t(`${this.$route.meta.title}.title_page`);
        this.page_title = document.title;

        let model = JSON.parse(localStorage.getItem('selected_ai_model'));
        if (!model) {
            this.$router.push({name: 'ai-model-list'});
        }
        this.aiModel.id = model.id;
        this.aiModel.name = model.name;
        this.aiModel.type = model.type;

        this.getAllInferences(this.aiModel.id);
        this.getAllFinishTrains(this.aiModel.id);
    },
    computed: {
        kintoneRecordConditionErrorMsg() {
            /*
            if (!this.$v.kintone_record_condition.required) {
                return this.$t('message_error.ORGANIZATION_NAME_REQUIRED');
            }
            */

            if (this.errors && this.errors.name) {
                return this.errors.name[0];
            }
            return null;
        },     
        modelTrainingIdErrorMsg() {
            if (!this.$v.model_training_id.required) {
                return this.$t('message_error.SELECT_TRAINING_MODEL');
            }
            if (this.errors && this.errors.name) {
                return this.errors.name[0];
            }
            return null;
        },
        kintonePredFieldPrefixErrorMsg() {
            if (!this.$v.pred_field_prefix.required) {
                return this.$t('message_error.ENTER_PREFIX_KINTONE_FIELD');
            }
            if (this.errors && this.errors.name) {
                return this.errors.name[0];
            }
            return null;
        },
        kintoneOptionThreshErrorMsg() {
            if (this.errors && this.errors.name) {
                return this.errors.name[0];
            }
            return null;
        },
        getLowestLossTrainIndex() {
            if (this.finishTraines.length > 0) {
                let lowestLoss = this.finishTraines[0].loss;
                let lowestLossIndex = this.finishTraines[0].index;

                for (let i = 0; i < this.finishTraines.length; i++) {
                    if (this.finishTraines[i].loss < lowestLoss) {
                        lowestLoss = this.finishTraines[i].loss;
                        lowestLossIndex = this.finishTraines[i].index;
                    }
                }
                return lowestLossIndex;
            }
            return -1;
        }  
    },
    validations() {
        return {
            kintone_record_condition: {  },
            model_training_id: { required },
            pred_field_prefix: { required },
            option_thresh: {  },
        }
    }
}